export var LineStyle;
(function (LineStyle) {
    LineStyle["solid"] = "solid";
    LineStyle["dashed"] = "dashed";
    LineStyle["dotted"] = "dotted";
})(LineStyle || (LineStyle = {}));
export var GrafosSymbol;
(function (GrafosSymbol) {
    GrafosSymbol["none"] = "none";
    GrafosSymbol["circle"] = "circle";
    GrafosSymbol["diamond"] = "diamond";
    GrafosSymbol["square"] = "square";
    GrafosSymbol["triangle"] = "triangle";
    GrafosSymbol["cross"] = "cross";
    GrafosSymbol["plus"] = "plus";
})(GrafosSymbol || (GrafosSymbol = {}));
//# sourceMappingURL=element.js.map